import React from "react";
import ModalBase from "./ModalBase";
import PropTypes from "prop-types";

// Specialized modal for data table interactions
const DataModal = ({
  children,
  title,
  visible,
  onHide,
  size = "large",
  showCloseButton = true,
  maximizable = true,
  resizable = true,
  ...props
}) => {
  return (
    <ModalBase
      header={title}
      visible={visible}
      onHide={onHide}
      footer={null}
      size={size}
      variant="data"
      maximizable={maximizable}
      resizable={resizable}
      {...props}
    >
      {children}
    </ModalBase>
  );
};

DataModal.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  visible: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  size: PropTypes.oneOf(["small", "medium", "large", "full"]),
  showCloseButton: PropTypes.bool,
  maximizable: PropTypes.bool,
  resizable: PropTypes.bool,
};

export default DataModal;
